<h1 mat-dialog-title>
  Detalhes da Notificação
</h1>

<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<div class="dialog-content">
  <app-form [campos]="camposDadosDetalhes" appearance="outline" #formDetalhes></app-form>
</div>

<div mat-dialog-actions align="end" *ngIf="notificacao?.lida === 'N'">
  <button type="button" mat-flat-button (click)="confirmarLeitura()">Confirmar Leitura</button>
</div>
